import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './button.html',
  styleUrls: ['./button.css'],
})
export class Button {
  @Input() text = 'Button';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant?: 'primary' | 'secondary' | 'danger' | 'outline' = 'primary';
  @Input() size?: 'sm' | 'md' | 'lg' = 'lg'; 
  @Input() iconPath?: string = ''; 
  @Input() loading = false;
  @Input() disabled = false;
  @Input() extraClass = '';

  @Output() action = new EventEmitter<Event>();

  onClick(event: Event) {
    if (this.type === 'button') {
      this.action.emit(event);
    }
  }

  get classes(): string {
    const base =
      'font-medium rounded-[20px] transition-all duration-200 cursor-pointer w-full text-base';

    const variants: Record<string, string> = {
      primary: 'text-white',
      secondary:
        'text-gray-800 bg-gray-200 hover:bg-gray-300 border border-gray-300',
      danger: 'text-white bg-red-500 hover:bg-red-600',
      outline:
        'text-(--brand-primary) border border-(--brand-primary) bg-transparent hover:bg-blue-50',
    };

    const sizes: Record<string, string> = {
      sm: 'px-3 py-2 text-sm',
      md: 'px-[20px] py-[14px]',
      lg: 'px-[24px] py-[18px]',
    };

    const state = this.disabled
      ? 'opacity-60 cursor-not-allowed pointer-events-none'
      : 'hover:opacity-90';

    return `${base} ${variants[this.variant ?? 'primary']} ${sizes[this.size ?? 'lg']} ${state} ${this.extraClass}`.trim();
  }
}
